import React from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { StyleQuiz } from './StyleQuiz';

export const StyleQuizContainer = (props) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const store = useStore();
  const { storeId, isLocalized } = store;
  const defaultVariables = {
    storeId,
    isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false
  };

  return (
    <QueryProvider defaultVariables={defaultVariables}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <StyleQuiz {...props} />
    </QueryProvider>
  );

};

StyleQuizContainer.propTypes = {};
